import React, { useState } from "react";
import ModalComp from "../themes/Model";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  createTheme,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  MenuItem,
  TextField,
  ThemeProvider,
} from "@mui/material";
import {
  CheckBox,
  CheckBoxOutlineBlank,
  TextFields,
} from "@mui/icons-material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import api from "../axiosConfig";
import { useModalContext } from "../ModalContext";
import { getUser } from "../helpers";
import { LoadingButton } from "@mui/lab";

function CreateScheme({
  open,
  setModalOpen,
  warehouses,
  setWarehouses,
  selectedWarehouse,
  setSelectedWarehouse,
  isWarehouseDisabled,
  channels,
  setChannels,
  selectedChannel,
  setSelectedChannel,
  isChannelDisabled,
  categories,
  setCategories,
  selectedCategory,
  setSelectedCategory,
  isPriceListDisabled,
  priceLists,
  setPriceLists,
  selectedPriceList,
  setSelectedPriceList,
  productNames,
  selectedProduct,
  setSelectedProduct,
  setSelectedProductCode,
  isProductDisabled,
  openNotification,
  setNotification,
  setNotificationText,
  isSchemeTypeDisabled,
  selectedPriceListValue,
  setSelectedPriceListValue,
  setSnackbarMessage,
  setSnackbarOpen,
  modalHeader,
  modalType,
  modalFormData,
  setModalFormData,
  resetForm,
  errors,
  setErrors,
}) {
  const { currency, isLoading, setLoading } = useModalContext();
  const user = getUser();
  const [adjustWithExistingQty, setAdjustWithExistingQty] = useState(0);
  //handel

  // warehouse handler
  const handleWarehouseChange = (event, newValue) => {
    // Check if "Select All" is selected
    if (newValue.some((item) => item.Warehouse === "Select All")) {
      // Toggle Select All
      const allSelected = selectedWarehouse.length === warehouses.length;
      const updatedSelection = allSelected
        ? []
        : warehouses.map((w) => w.Warehouse);

      setSelectedWarehouse(updatedSelection);

      // Update form data
      setModalFormData((prevData) => ({
        ...prevData,
        warehouse: updatedSelection, // Update warehouse field in form data
      }));

      // No error if all selected, or none selected (empty selection)
      setErrors((prevErrors) => ({
        ...prevErrors,
        warehouse:
          updatedSelection.length > 0 ? null : "This field is required",
      }));
    } else {
      // Handle normal selection
      const selectedValues = newValue.map((item) => item.Warehouse);
      setSelectedWarehouse(selectedValues);

      setModalFormData((prevData) => ({
        ...prevData,
        warehouse: selectedValues, // Update warehouse field in form data
      }));

      // Set error if selection is empty
      setErrors((prevErrors) => ({
        ...prevErrors,
        warehouse: selectedValues.length ? null : "This field is required",
      }));
    }
  };

  //channel handler
  const handleChannelChange = async (event, newValue) => {
    const newSelectedChannels = newValue.map((item) => item.Channel);

    if (newSelectedChannels.includes("Select All")) {
      const allSelected = selectedChannel.length === channels.length;
      const allChannels = allSelected ? [] : channels.map((c) => c.Channel);
      setSelectedChannel(allChannels);

      setModalFormData((prevData) => ({
        ...prevData,
        channel: allChannels,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        channel: allChannels.length ? null : "Please select a channel",
      }));
    } else {
      setSelectedChannel(newSelectedChannels);
      setModalFormData((prevData) => ({
        ...prevData,
        channel: newSelectedChannels,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        channel: newSelectedChannels.length ? null : "Please select a channel",
      }));
    }
    try {
      const response = await api.post("/pricelist", {
        channel: newSelectedChannels.join(", "),
        page: "scheme",
        user: user,
      });
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching pricelist:", error);
    }
  };

  //categories = (price-list) handler
  const handleCategoryChange = (event, newValue) => {
    const newSelectedCategories = newValue.map((item) => item.Pricelist);

    if (newSelectedCategories.includes("Select All")) {
      const allSelected = selectedCategory.length === categories.length;
      const allCategories = allSelected
        ? []
        : categories.map((c) => c.Pricelist);
      setSelectedCategory(allCategories);

      setModalFormData((prevData) => ({
        ...prevData,
        pricelist: allCategories,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        pricelist:
          allCategories.length === 0
            ? "Please select at least one pricelist"
            : "",
      }));
    } else {
      setSelectedCategory(newSelectedCategories);
      setModalFormData((prevData) => ({
        ...prevData,
        pricelist: newSelectedCategories,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        pricelist:
          newSelectedCategories.length === 0
            ? "Please select at least one pricelist"
            : "",
      }));
    }
  };

  //product handler
  const handleProductChange = (event, newValue) => {
    const newSelectedProducts = newValue.map((item) => item.Product_Name);
    const selectedCodes = newValue.map((item) => item.ProductCode);
    const selectedProductCode = newValue ? newValue.productCode : null;
    setSelectedProductCode(selectedProductCode);

    if (newSelectedProducts.includes("Select All")) {
      const allSelected = selectedProduct.length === productNames.length;
      const allProducts = allSelected
        ? []
        : productNames.map((p) => p.Product_Name);
      const allProductCodes = allSelected
        ? []
        : productNames.map((p) => p.ProductCode);

      setSelectedProduct(allProducts);

      setModalFormData((prevData) => ({
        ...prevData,
        productName: allProducts,
        product: allProductCodes,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        product: allProducts.length ? null : "Please select a product",
      }));
    } else {
      setSelectedProduct(newSelectedProducts);

      setModalFormData((prevData) => ({
        ...prevData,
        productName: newSelectedProducts,
        product: selectedCodes,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        product: newSelectedProducts.length ? null : "Please select a product",
      }));
    }
  };

  // handel change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setModalFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Clear the field-specific error if valid input is entered
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear error for the specific field being updated
    }));

    if (openNotification) {
      setNotification(false);
      setNotificationText("");
    }
  };
  const handleCheckboxChange = (event) => {
    setAdjustWithExistingQty(event.target.checked ? 1 : 0);
  };

  // date picker style
  const customTheme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-input": {
              fontSize: "14px", // Font size for the input field
            },
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for the calendar days
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for typography inside the Date Picker
          },
        },
      },
    },
  });

  //icons
  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;

  // dropdown data
  const mrpRate = [
    { MrpValue: "MRP", name: "MRP" },
    { MrpValue: "PTR", name: "PTR" },
  ];

  //reset-form
  const handelCloseModal = () => {
    resetForm();
    setModalOpen(false);
    setSelectedWarehouse([]);
    setSelectedChannel([]);
    setSelectedCategory([]);
    setSelectedProduct([]);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!modalFormData.schemeName || modalFormData.schemeName.trim() === "")
      newErrors.schemeName = "Scheme Name is required";

    if (!modalFormData.schemeType || modalFormData.schemeType.trim() === "")
      newErrors.schemeType = "Scheme Type is required";

    if (!modalFormData.warehouse || modalFormData.warehouse.length === 0)
      newErrors.warehouse = "Warehouse is required";

    if (!modalFormData.product || modalFormData.product.length === 0)
      newErrors.product = "Product is required";

    if (!modalFormData.channel || modalFormData.channel.length === 0)
      newErrors.channel = "Channel is required";

    if (!modalFormData.schemeStartDate)
      newErrors.schemeStartDate = "Start date is required";

    if (!modalFormData.schemeEndDate)
      newErrors.schemeEndDate = "End date is required";

    if (modalFormData.schemeStartDate && modalFormData.schemeEndDate) {
      const start = dayjs(modalFormData.schemeStartDate);
      const end = dayjs(modalFormData.schemeEndDate);
      if (end.isBefore(start))
        newErrors.schemeEndDate = "End date cannot be before start date";
    }

    if (!modalFormData.pricelist || modalFormData.pricelist.length === 0)
      newErrors.pricelist = "Please select at least one pricelist";

    // if (!modalFormData.mrpRate) newErrors.mrpRate = "MRP is required";
    // else if (isNaN(modalFormData.mrpRate))
    //   newErrors.mrpRate = "MRP must be a number";

    // if (!modalFormData.ptr) newErrors.ptr = "PTR is required";
    // else if (isNaN(modalFormData.ptr)) newErrors.ptr = "PTR must be a number";

    // Conditional Validations Based on Scheme Type
    if (modalFormData.schemeType === "Off Invoice") {
      if (!modalFormData.quantityImpact)
        newErrors.quantityImpact = "Quantity Impact is required";
      else if (isNaN(modalFormData.quantityImpact))
        newErrors.quantityImpact = "Quantity Impact must be a number";
    }

    if (modalFormData.schemeType === "Visibility") {
      if (!modalFormData.quantityImpact)
        newErrors.quantityImpact = "Quantity Impact is required";
      else if (isNaN(modalFormData.quantityImpact))
        newErrors.quantityImpact = "Quantity Impact must be a number";

      if (!modalFormData.schemeImpactValue)
        newErrors.schemeImpactValue = "Scheme Impact Value is required";
      else if (isNaN(modalFormData.schemeImpactValue))
        newErrors.schemeImpactValue = "Scheme Impact Value must be a number";
    }

    if (
      modalFormData.schemeType === "On Invoice" ||
      modalFormData.schemeType === "Off Invoice"
    ) {
      if (!modalFormData.mrpRate || modalFormData.mrpRate.trim() === "")
        newErrors.mrpRate = "Discount Pricing Impact is required";

      if (!modalFormData.rateImpact)
        newErrors.rateImpact = "Rate Impact is required";
      else if (isNaN(modalFormData.rateImpact))
        newErrors.rateImpact = "Rate Impact must be a number";

      if (!modalFormData.quantityImpact)
        newErrors.quantityImpact = "Quantity Impact is required";
      else if (isNaN(modalFormData.quantityImpact))
        newErrors.quantityImpact = "Quantity Impact must be a number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //update apiEndpoint
  const handleCreateSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    // API endpoint and payload
    const apiEndpoint = "/api/scheme/addnew";

    const payload = {
      body: {
        schemeName: modalFormData.schemeName,
        warehouse: modalFormData.warehouse,
        schemeStartDate: modalFormData.schemeStartDate,
        schemeEndDate: modalFormData.schemeEndDate,
        channel: modalFormData.channel,
        pricelist: modalFormData.pricelist,
        schemeType: modalFormData.schemeType,
        user,
        page: "scheme",
        currencyType: "Native",
        rateImpact: modalFormData.rateImpact,
        quantityImpact: modalFormData.quantityImpact,
        schemeImpactValue: modalFormData.schemeImpactValue,
        product: modalFormData.product,
        adjustWithExistingQty: adjustWithExistingQty || 0,
        mrpRate: modalFormData.mrpRate,
      },
    };
    setLoading(true);

    api
      .post(apiEndpoint, payload)
      .then((response) => {
        if (!response.data.Status) {
          setNotificationText(
            response.data.SchemeStatus || "An error occurred, please try again."
          );
          setNotification(true);
          setModalOpen(true);
          setLoading(false);
        } else {
          // Success case
          setSnackbarMessage("Your new scheme request has been submitted.");
          setSnackbarOpen(true); // Show the snackbar
          handelCloseModal();
          setNotification(false);
          setNotificationText(""); // Reset notification
          setSelectedPriceList("");
          setModalOpen(false);
          //   handleCloseModal();
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error during API call:", error);
        setNotificationText(
          "An error occurred while submitting the data. Please try again."
        );
        setNotification(true);
        setModalOpen(true);
        setLoading(false);
      });
  };

  //create scheme modal content
  const modalContent = (
    <>
      <Box>
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Scheme Name"
                name="schemeName"
                value={modalFormData.schemeName}
                onChange={(e) => {
                  const value = e.target.value;
                  setModalFormData((prevData) => ({
                    ...prevData,
                    schemeName: value,
                  }));
                  if (value) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      schemeName: "",
                    }));
                  }
                }}
                error={Boolean(errors.schemeName)}
                size="small"
              />
              {errors.schemeName && (
                <FormHelperText
                  sx={{
                    color: "#FF0000",
                    marginTop: "4px",
                  }}
                >
                  {errors.schemeName}*
                </FormHelperText>
              )}
            </Grid>

            <ThemeProvider theme={customTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box
                  className="scheme-date-picker"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "20px",
                    marginTop: "20px",
                    marginLeft: "16px",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <DatePicker
                      label="Scheme Start Date"
                      sx={{ width: "100%" }}
                      value={
                        modalFormData.schemeStartDate
                          ? dayjs(modalFormData.schemeStartDate)
                          : null
                      }
                      onChange={(newValue) => {
                        setModalFormData((prevData) => ({
                          ...prevData,
                          schemeStartDate: newValue
                            ? newValue.format("YYYY-MM-DD")
                            : "",
                        }));
                        if (newValue) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            schemeStartDate: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          margin="normal"
                          error={Boolean(errors.schemeStartDate)}
                        />
                      )}
                      disablePast={modalType !== "actual"}
                      shouldDisableDate={(date) => {
                        // if (modalType !== "scheme") return false;

                        const today = dayjs().startOf("day");
                        const tomorrow = today.add(1, "day");
                        const endDate = modalFormData.schemeEndDate
                          ? dayjs(modalFormData.schemeEndDate)
                          : null;

                        return (
                          date.isSame(today, "day") ||
                          date.isSame(tomorrow, "day") ||
                          (endDate && date.isAfter(endDate, "day"))
                        );
                      }}
                    />
                    {errors.schemeStartDate && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000",
                          marginTop: "4px",
                        }}
                      >
                        {errors.schemeStartDate}*
                      </FormHelperText>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <DatePicker
                      label="Scheme End Date"
                      sx={{ width: "100%" }}
                      value={
                        modalFormData.schemeEndDate
                          ? dayjs(modalFormData.schemeEndDate)
                          : null
                      }
                      onChange={(newValue) => {
                        setModalFormData((prevData) => ({
                          ...prevData,
                          schemeEndDate: newValue
                            ? newValue.format("YYYY-MM-DD")
                            : "",
                        }));
                        if (newValue) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            schemeEndDate: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth margin="normal" />
                      )}
                      disablePast={modalType !== "actual"}
                      shouldDisableDate={(date) => {
                        const today = dayjs().startOf("day");
                        const tomorrow = today.add(1, "day");
                        const startDate = modalFormData.schemeStartDate
                          ? dayjs(modalFormData.schemeStartDate)
                          : dayjs().startOf("day");
                        return (
                          date.isSame(today, "day") ||
                          date.isSame(tomorrow, "day") ||
                          date.isBefore(startDate, "day")
                        );
                      }}
                    />
                    {errors.schemeEndDate && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000",
                          marginTop: "4px",
                        }}
                      >
                        {errors.schemeEndDate}*
                      </FormHelperText>
                    )}
                  </Box>
                </Box>
              </LocalizationProvider>
            </ThemeProvider>

            <>
              <Grid item xs={6}>
                <FormControl
                  variant="outlined"
                  error={!!errors.warehouse}
                  sx={{
                    minWidth: 200,
                    width: "100%",
                    height: "50%",
                    flexGrow: 1,
                    border: "1px solid white",
                    color: "white",
                  }}
                >
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={[{ Warehouse: "Select All" }, ...warehouses]}
                    getOptionLabel={(option) => option.Warehouse}
                    value={
                      Array.isArray(selectedWarehouse)
                        ? selectedWarehouse.map((warehouse) =>
                            warehouses.find((w) => w.Warehouse === warehouse)
                          )
                        : []
                    }
                    onChange={handleWarehouseChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Warehouse"
                        placeholder="Search..."
                        error={!!errors.warehouse}
                      />
                    )}
                    renderTags={(selected, getTagProps) => [
                      ...selected
                        .slice(0, 2)
                        .map((option, index) => (
                          <Chip
                            key={option.Warehouse}
                            label={option.Warehouse}
                            {...getTagProps({ index })}
                          />
                        )),
                      selected.length > 2 ? (
                        <Chip
                          key="more"
                          label={`+${selected.length - 2} more`}
                          sx={{
                            backgroundColor: "#149485",
                            color: "white",
                          }}
                        />
                      ) : null,
                    ]}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          checked={
                            option.Warehouse === "Select All"
                              ? selectedWarehouse.length === warehouses.length
                              : selected
                          }
                          sx={{
                            color: "#149485",
                            "&.Mui-checked": {
                              color: "#149485",
                            },
                          }}
                        />
                        {option.Warehouse}
                      </li>
                    )}
                    sx={{
                      "& .MuiAutocomplete-tag": {
                        backgroundColor: "#149485",
                        color: "white",
                      },
                      "& .MuiInputBase-input": {
                        color: "black",
                        backgroundColor: "white",
                      },
                    }}
                    size="small"
                  />
                  {errors.warehouse && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000 !important",
                        marginTop: "4px !important",
                        marginLeft: "0",
                        marginRight: "0",
                      }}
                    >
                      {errors.warehouse}*
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6} sx={{ marginTop: "5px" }}>
                <FormControl
                  variant="outlined"
                  error={!!errors.channel}
                  style={{ width: "100%", flexGrow: 1 }}
                >
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={[{ Channel: "Select All" }, ...channels]}
                    getOptionLabel={(option) => option.Channel}
                    value={
                      Array.isArray(selectedChannel)
                        ? selectedChannel.map((channel) =>
                            channels.find((c) => c.Channel === channel)
                          )
                        : []
                    }
                    onChange={handleChannelChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Channel"
                        placeholder="Search..."
                        fullWidth
                        error={!!errors.channel}
                      />
                    )}
                    renderTags={(selected, getTagProps) => [
                      ...selected
                        .slice(0, 2)
                        .map((option, index) => (
                          <Chip
                            key={option.Channel}
                            label={option.Channel}
                            {...getTagProps({ index })}
                          />
                        )),
                      selected.length > 2 ? (
                        <Chip
                          key="more"
                          label={`+${selected.length - 2} more`}
                          sx={{
                            backgroundColor: "#149485",
                            color: "white",
                          }}
                        />
                      ) : null,
                    ]}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          checked={
                            option.Channel === "Select All"
                              ? selectedChannel.length === channels.length
                              : selected
                          }
                          sx={{
                            color: "#149485",
                            "&.Mui-checked": {
                              color: "#149485",
                            },
                          }}
                        />
                        {option.Channel}
                      </li>
                    )}
                    sx={{
                      "& .MuiAutocomplete-tag": {
                        backgroundColor: "#149485",
                        color: "white",
                      },
                    }}
                    size="small"
                  />
                  {errors.channel && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000 !important",
                        marginTop: "4px !important",
                        marginLeft: "0",
                        marginRight: "0",
                      }}
                    >
                      {errors.channel}*
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  variant="outlined"
                  error={!!errors.pricelist}
                  style={{ width: "100%", flexGrow: 1 }}
                >
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={[{ Pricelist: "Select All" }, ...categories]}
                    getOptionLabel={(option) => option.Pricelist}
                    value={selectedCategory.map((category) =>
                      categories.find((c) => c.Pricelist === category)
                    )}
                    onChange={handleCategoryChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Pricelist"
                        placeholder="Search..."
                        fullWidth
                        error={!!errors.pricelist}
                      />
                    )}
                    renderTags={(selected, getTagProps) => [
                      ...selected
                        .slice(0, 2)
                        .map((option, index) => (
                          <Chip
                            key={option.Pricelist}
                            label={option.Pricelist}
                            {...getTagProps({ index })}
                          />
                        )),
                      selected.length > 2 ? (
                        <Chip
                          key="more"
                          label={`+${selected.length - 2} more`}
                          sx={{
                            backgroundColor: "#149485",
                            color: "white",
                          }}
                        />
                      ) : null,
                    ]}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          checked={
                            option.Pricelist === "Select All"
                              ? selectedCategory.length === categories.length
                              : selected
                          }
                          sx={{
                            color: "#149485",
                            "&.Mui-checked": {
                              color: "#149485",
                            },
                          }}
                        />
                        {option.Pricelist}
                      </li>
                    )}
                    sx={{
                      "& .MuiAutocomplete-tag": {
                        backgroundColor: "#149485",
                        color: "white",
                      },
                    }}
                    size="small"
                  />
                  {errors.pricelist && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000 !important",
                        marginTop: "4px !important",
                        marginLeft: "0",
                        marginRight: "0",
                      }}
                    >
                      {errors.pricelist}*
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  variant="outlined"
                  error={!!errors.product}
                  style={{ width: "100%" }}
                >
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={[{ Product_Name: "Select All" }, ...productNames]}
                    getOptionLabel={(option) => option.Product_Name}
                    value={
                      Array.isArray(selectedProduct)
                        ? selectedProduct.map((name) =>
                            productNames.find((p) => p.Product_Name === name)
                          )
                        : []
                    }
                    onChange={handleProductChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Product"
                        placeholder="Search..."
                        fullWidth
                        error={!!errors.product}
                      />
                    )}
                    renderTags={(selected, getTagProps) => [
                      ...selected.slice(0, 2).map((option, index) => (
                        <Chip
                          key={option.Product_Name}
                          label={option.Product_Name}
                          {...getTagProps({ index })}
                          sx={{
                            backgroundColor: "#149485",
                            color: "white",
                          }}
                        />
                      )),
                      selected.length > 2 ? (
                        <Chip
                          key="more"
                          label={`+${selected.length - 2} more`}
                          sx={{
                            backgroundColor: "#149485",
                            color: "white",
                          }}
                        />
                      ) : null,
                    ]}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          checkedIcon={checkedIcon}
                          icon={icon}
                          checked={
                            option.Product_Name === "Select All"
                              ? selectedProduct.length === productNames.length
                              : selected
                          }
                          sx={{
                            color: "#149485",
                            "&.Mui-checked": {
                              color: "#149485",
                            },
                          }}
                        />
                        {option.Product_Name}
                      </li>
                    )}
                    sx={{
                      "& .MuiAutocomplete-tag": {
                        backgroundColor: "#149485",
                        color: "white",
                      },
                    }}
                    size="small"
                  />
                  {errors.product && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000 !important",
                        marginTop: "4px !important",
                        marginLeft: "0",
                        marginRight: "0",
                      }}
                    >
                      {errors.product}*
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </>

            <Grid item xs={12}>
              <TextField
                fullWidth
                select
                label="Scheme Type"
                name="schemeType"
                value={modalFormData.schemeType}
                onChange={handleChange}
                error={!!errors.schemeType}
                helperText={errors.schemeType || ""}
                disabled={isSchemeTypeDisabled}
                size="small"
              >
                {["On Invoice", "Off Invoice", "Visibility"].map(
                  (type, index) => (
                    <MenuItem
                      key={index}
                      value={type}
                      disabled={modalType === "actual" && type === "On Invoice"}
                    >
                      {type}
                    </MenuItem>
                  )
                )}
              </TextField>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {["On Invoice", "Off Invoice"].includes(
                modalFormData.schemeType
              ) && (
                <TextField
                  fullWidth
                  select
                  label="Discount Pricing Impact"
                  name="mrpRate"
                  value={modalFormData.mrpRate || ""}
                  onChange={handleChange}
                  error={!!errors.mrpRate}
                  helperText={errors.mrpRate || ""}
                  size="small"
                >
                  {mrpRate.map((rate, index) => (
                    <MenuItem key={index} value={rate.MrpValue}>
                      {rate.name}
                    </MenuItem>
                  ))}
                </TextField>
              )}

              {/* Conditionally render Rate Impact and Quantity Impact based on Scheme Type */}
              <Box
                sx={{
                  display: "flex",
                  gap: "20px",
                }}
              >
                {["On Invoice", "Off Invoice"].includes(
                  modalFormData.schemeType
                ) && (
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Rate Impact (-) %"
                      name="rateImpact"
                      value={modalFormData.rateImpact}
                      error={!!errors.rateImpact}
                      helperText={errors.rateImpact || ""}
                      onChange={handleChange}
                      size="small"
                    />
                  </Grid>
                )}

                {["On Invoice", "Off Invoice", "Visibility"].includes(
                  modalFormData.schemeType
                ) && (
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Quantity Impact in %"
                      name="quantityImpact"
                      value={modalFormData.quantityImpact || ""}
                      onChange={handleChange}
                      size="small"
                      error={Boolean(errors.quantityImpact)}
                    />

                    {errors.quantityImpact && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000",
                          marginTop: "4px",
                        }}
                      >
                        {errors.quantityImpact}*
                      </FormHelperText>
                    )}
                  </Grid>
                )}
              </Box>

              {["Visibility"].includes(modalFormData.schemeType) && (
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Scheme Impact Value"
                    name="schemeImpactValue"
                    value={modalFormData.schemeImpactValue}
                    onChange={handleChange}
                    size="small"
                    error={Boolean(errors.schemeImpactValue)}
                  />

                  {errors.schemeImpactValue && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000",
                        marginTop: "4px",
                      }}
                    >
                      {errors.schemeImpactValue}*
                    </FormHelperText>
                  )}
                </Grid>
              )}
              {["On Invoice", "Off Invoice"].includes(
                modalFormData.schemeType
              ) && (
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={adjustWithExistingQty === 1}
                        onChange={handleCheckboxChange}
                        sx={{
                          color: "#149485",
                          "&.Mui-checked": {
                            color: "#149485",
                            width: "fit-content",
                          },
                        }}
                      />
                    }
                    label="Adjust with existing qty"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px", // Set font size for the label
                      },
                    }}
                  />
                </FormGroup>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );

  //   modelButtons
  const actionButtons = (
    <>
      <Box sx={{ textAlign: "right" }}>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={isLoading}
          loadingPosition="end"
          onClick={handleCreateSubmit}
          style={{
            backgroundColor: "#16a695",
            color: "white",
            backgroundColor: isLoading ? "#16a69590" : "#16a695",
            paddingRight: isLoading ? "35px" : "",
          }}
          size="small"
        >
          {"Request New Scheme"}
        </LoadingButton>
        &nbsp;&nbsp;&nbsp;
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handelCloseModal();
          }}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #707070",
            borderColor: "#707070",
            color: "#000",
          }}
          size="small"
        >
          Close
        </Button>
      </Box>
    </>
  );

  return (
    <>
      <ModalComp
        open={open}
        setModalOpen={setModalOpen}
        handelCloseModal={handelCloseModal}
        title={"Create scheme"}
        modalContent={modalContent}
        modelButtons={actionButtons}
        datePickerStyle={{ width: "48%", margin: "5px" }}
        themeStyles={{
          boxStyle: {
            width: "682px",
            height: "auto",
            margin: "auto",
            marginTop: "80px",
          },
          titleStyle: {
            fontSize: "18px",
            fontWeight: 600,
            color: "#000",
            backgroundColor: "#F4F4F4",
            padding: "24px",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          fieldStyle: { width: "100%", marginTop: "20px" },
          actionButtonContainerStyle: {
            padding: "0 20px 20px 20px",
          },
        }}
      />
    </>
  );
}

export default CreateScheme;
